import { ColumnDef } from "@tanstack/react-table";
import { Checkbox } from "~/components/ui/checkbox";
import { format } from "date-fns";

export const columns: ColumnDef<any>[] = [
  {
    id: "select",
    header: ({ table }) => (
      <Checkbox
        checked={table.getIsAllPageRowsSelected()}
        onCheckedChange={(value) => table.toggleAllPageRowsSelected(!!value)}
        aria-label="Select all"
      />
    ),
    cell: ({ row }) => (
      <Checkbox
        checked={row.getIsSelected()}
        onCheckedChange={(value) => row.toggleSelected(!!value)}
        aria-label="Select row"
      />
    ),
    enableSorting: false,
    enableHiding: false,
  },
  {
    accessorKey: "reference",
    header: "Reference",
  },
  {
    accessorKey: "title",
    header: "Title",
  },
  {
    accessorKey: "permitType",
    header: "Permit Type",
  },
  {
    accessorKey: "status",
    header: "Status",
    cell: ({ row }) => {
      const val = row.getValue("status");
      if (val === 0) return "Draft";
      if (val === 1) return "Pending Approval";
      if (val === 2) return "Issued";
      if (val === 3) return "Suspended";
      if (val === 4) return "Closed";
      if (val === 5) return "Cancelled";
      return "Unknown";
    },
  },
  {
    accessorKey: "validFrom",
    header: "Valid From",
    cell: ({ row }) => {
      const val = row.getValue("validFrom") as string;
      return <span>{val ? format(new Date(val), "PPp") : "-"}</span>;
    },
  },
  {
    accessorKey: "validTo",
    header: "Valid To",
    cell: ({ row }) => {
      const val = row.getValue("validTo") as string;
      return <span>{val ? format(new Date(val), "PPp") : "-"}</span>;
    },
  },
  {
    accessorKey: "createdAt",
    header: "Created At",
    cell: ({ row }) => {
      const val = row.getValue("createdAt") as string;
      return <span>{val ? format(new Date(val), "PPp") : ""}</span>;
    },
  },
];
